export default "__VITE_ASSET__91f91523__"